import React, { Component } from 'react'
import { connect } from 'react-redux'

import '@/companys/ttl/assets/styles/components/detail-center/hnews.scss'

import News from './News'
import Announcement from './Announcement'
import Report from './Report'

import { utilsFunction,keyDownFunctions,accessibilityFunctions } from "@/helpers/functions";

class HNews extends Component {
    constructor(props){
        super(props)
        this.state = {
            HeadSelect:['market_news','marker_announcement','market_report'],
            HeadIndex:0
        }
    }
    render() {
        const {language} = this.props
        const {HeadIndex,HeadSelect} = this.state
        return (
            <div className='head_news' >
                <div className='head_select' >
                  { HeadSelect.map((item,index)=>{
                    return ( <div key={item} className={ HeadIndex == index ? 'active_head' : 'inactive_head'} onClick={()=> this.handleHead(index)} 
                                  onKeyDown={keyDownFunctions.handleEnterKeyDown(() => this.handleHead(index))}
                                  {...accessibilityFunctions.hasTabIndex()}>
                                  {language[item]}
                                </div> )
                }) }  
                </div>
               <div className='new_content' >
                    { HeadIndex == 0 && <News innerRef={e => this.NewsRef = e}/> }
                    { HeadIndex == 1 && <Announcement innerRef={e => this.AnnouncementRef = e} /> }
                    { HeadIndex == 2 && <Report innerRef={e => this.ReportRef = e} /> } 
                </div> 
            </div>
        )
    }
    componentDidMount(){
        this.props.innerRef(this)
    }
    componentDidUpdate(preProps){
        const { marketParams , language } = this.props;
        const { marketID, stockCode } = marketParams;
        // if(Number(10000)<=Number(stockCode) && Number(stockCode)<=20000 && marketID ==='HKEX' || !stockCode) return;
        if (marketParams && marketParams !== preProps.marketParams) {
          if (utilsFunction.instrumentIDZeroPadding(stockCode) !== utilsFunction.instrumentIDZeroPadding(preProps.marketParams.stockCode)) {
            this.refresh()
          }
        }
        if (language && preProps.language !== language) {
            this.refresh()
        }
    }

    handleHead = (index) => {
        this.setState({
            HeadIndex:index
        })
    }
    refresh = () => {
       switch(this.state.HeadIndex){
           case 0:
               this.NewsRef.getNewsData()
               break;
            case 1:
                this.AnnouncementRef.getAnnouncementData()
                break;
            case 2:
                this.ReportRef.getReportData()
                break;
       }
    }
}


export default connect(state => ({
    language: state.app.language,
    marketParams: state.trade.marketParams
}),dispatch => ({

}))(HNews)
